import { Box, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import ResetWrenchIcon from '@/img/material_symbols/ResetWrenchIcon';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import ErrorUtil from '@/util/ErrorUtil';
import ReactComponent from '../ReactComponent';
import ModalConfirmacao from './ModalConfirmacao';

class ForcarAtualizacaoEmentaDecisao extends ReactComponent {
    modalConfirmacaoOpen = false;
    processando = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            modalConfirmacaoOpen: observable,
            processando: observable,
            registro: computed,
            cursor: computed,
            forcarAtualizacaoEmentaDecisao: action,
            handleClickForcarAtualizacaoEmentaDecisao: action,
            callbackConfirmarAtualizacaoEmentaDecisao: action,
            callbackCancelarAtualizacaoEmentaDecisao: action
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get cursor() {
        return this.processando ? 'wait' : 'pointer';
    }

    forcarAtualizacaoEmentaDecisao = async () => {
        if (this.processando) {
            return;
        }

        try {
            this.processando = true;
            await this.salaSessaoStore.forcarAtualizacaoEmentaDecisao(this.registro);
            await this.salaSessaoStore.carregarEmentaDecisao(this.registro);
            this.mensagemStore.abrirMensagemSucesso('Textos de ementa e decisão atualizados com sucesso.');
        } catch (error) {
            this.mensagemStore.abrirMensagemErro(
                `Falha ao forçar atualização de ementa e decisão: ${ErrorUtil.montarMensagemErro(error)}`
            );
            console.error(error);
        } finally {
            runInAction(() => {
                this.processando = false;
            });
        }
    };

    handleClickForcarAtualizacaoEmentaDecisao = () => {
        this.modalConfirmacaoOpen = true;
    };

    callbackConfirmarAtualizacaoEmentaDecisao = async () => {
        this.modalConfirmacaoOpen = false;
        await this.forcarAtualizacaoEmentaDecisao();
    };

    callbackCancelarAtualizacaoEmentaDecisao = () => {
        this.modalConfirmacaoOpen = false;
    };

    renderModalAtualizacaoEmentaDecisao() {
        return (
            <ModalConfirmacao
                open={this.modalConfirmacaoOpen}
                callbackConfirmar={this.callbackConfirmarAtualizacaoEmentaDecisao}
                callbackCancelar={this.callbackCancelarAtualizacaoEmentaDecisao}
                titulo={'Confirmação de atualização de ementa e decisão'}
            >
                <Stack
                    direction="row"
                    spacing={2}
                >
                    <Box>
                        <ResetWrenchIcon
                            sx={{
                                fill: 'black',
                                fillOpacity: '0.9',
                                verticalAlign: 'middle',
                                width: '48px',
                                height: '48px'
                            }}
                        />
                    </Box>
                    <Box>
                        <Typography
                            align={'justify'}
                            sx={{ fontStyle: 'italic' }}
                        >
                            <b>O que acontecerá ao confirmar essa ação?</b> Os textos da ementa e da decisão são
                            armazenados em campos específicos nos sistemas de origem (SAG e PJe). Diante disso,
                            eventualmente, pode haver dessincronismo entre essas informações e o conteúdo da minuta de
                            voto/acórdão. Ao confirmar a ação desse botão, o voto será consultado no sistema de origem,
                            a ementa e a decisão serão extraídas do texto, e esses campos serão atualizados,
                            reestabelecendo o vínculo entre os dados.
                        </Typography>
                        <Typography sx={{ mt: 2 }}>
                            <b>Deseja confirmar a atualização dos textos de ementa e decisão?</b>
                        </Typography>
                    </Box>
                </Stack>
            </ModalConfirmacao>
        );
    }

    get titulo() {
        return 'Forçar atualização dos textos ementa e decisão';
    }

    render() {
        if (!this.isComponenteHabilitado('ForcarAtualizacaoEmentaDecisaoGE')) {
            return null;
        }

        return (
            <Box sx={{ cursor: this.cursor }}>
                <Tooltip title={<Typography>{this.titulo}</Typography>}>
                    <span>
                        <IconButton
                            onClick={this.handleClickForcarAtualizacaoEmentaDecisao}
                            disabled={this.processando}
                        >
                            <ResetWrenchIcon sx={{ fill: 'black', fillOpacity: '0.9' }} />
                        </IconButton>
                    </span>
                </Tooltip>
                {this.renderModalAtualizacaoEmentaDecisao()}
            </Box>
        );
    }
}

export default inject('stores')(observer(ForcarAtualizacaoEmentaDecisao));
